<style>
@font-face {
  font-family: 'rosita';
  src: url('../src/assets/fonts/Rosita.ttf');
  font-display: swap;
}

@font-face {
  font-family: 'lato';
  src: url('../src/assets/fonts/Lato-Regular.ttf');
  font-display: swap;
}

#app {
  font-family: 'Lato', Helvetica, Arial, sans-serif;
  text-transform: uppercase;
  box-sizing: border-box;
}

.rosita {
  font-family: rosita, Helvetica, Arial, sans-serif;
}

header {
  position: fixed;
  top: 0;
  left: 0;
  display: flex;
  flex-direction: column;
  border-bottom: 1px solid rgba(0,0,0,.2);
  background-color: rgba(255,255,255,.90);
  width: 100vw;
  z-index: 998;
}

.header-container {
  padding: 0.5rem 1rem;
}

.skip-links {
  margin: 0;
  padding: 0;
  list-style-type: none;
}

.skip-links a {
  position: absolute;
  top: -3rem;
}

.skip-links a:focus {
  top:0;
}

.menu-button {
  cursor: pointer;
}

a {
  color: #000000;
  text-decoration: none;
  cursor: pointer;
}

a.router-link-exact-active {
  text-decoration: underline;
}

.navbar-header {
  display: flex;
  flex-direction: row;
  justify-content: space-between;
  align-content: center;
}

.navbar {
  display: flex;
  flex-direction: column;
  align-items: center;
  text-transform: uppercase;
  max-height: 0;
  transition: max-height 0.3s ease-out;
  overflow: hidden;
  font-size: 1rem;
}

.navbar.active {
  max-height: 500px;
  transition: max-height 0.60s ease-in;
}

.navbar a {
  margin: 10px 0;
}

.title {
  font-size: 1.2rem;
  font-weight: 500;
  letter-spacing: 1px;
  margin-block-end: 0;
  margin-block-start: 0;
}

footer {
  margin-top: 3.5rem;
  padding: 0 1rem;
  bottom: 0;
}

.instagram-feed .title {
  font-family: rosita, Helvetica, Arial, sans-serif;
  text-transform: initial;
  font-size: 2.5rem;
  font-weight: unset;
}

.instagram-feed .subtitle {
  text-transform: lowercase;
}

.copy-rigth {
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;
  padding: 15px 0;
  border-top: 1px solid rgba(0,0,0,.2);
  margin: 25px auto;
  clear: both;
  font-size: 0.8rem;
  color: black;
  letter-spacing: 2px;
  font-weight: 500;
  letter-spacing: 1px;
}

.social-links {
  margin-top: 10px;
}

.social-links a {
  cursor: pointer;
  margin: 0 5px;
}

@media (min-width: 610px) {
  header {
    height: 60px;
    justify-content: center;
  }

  .menu-button {
    display: none;
  }

  .navbar-header {
    justify-content: center;
  }

  .navbar {
    display: flex;
    flex-direction: row;
    max-height: unset;
    text-align: center;
    justify-content: center;
    margin-top: 4px;
    font-size: 0.75rem;
  }

  .navbar a {
    margin: 0 10px;
  }

  .copy-rigth {
    flex-direction: row;
    justify-content: space-between;
    align-items: center;
  }

  .copy-rigth span {
    margin-top: 0px;
  }

  #app {
    max-width: 1024px;
    margin: 0 auto;
  }
}

/* Transitions */
.appear-enter {
  opacity: 0;
}

.appear-enter-active {
  transition: opacity 2s;
}
</style>
<template>
  <div id="app">
    <ul class="skip-links">
      <li><a href="#navbar">Skip to navigation</a></li>
      <li><a href="#main-content">Skip to main content</a></li>
    </ul>
    <header>
      <div class="header-container">
        <div class="navbar-header">
          <h1 class="title">no hay puntada sin hilo</h1>
          <div class="menu-button">
            <img @click="showMenu" alt="menu" src="@/assets/icons/reorder.svg">
          </div>
        </div>
        <nav>
          <div :class="{active: menuOpen}" id="navbar" class="navbar">
              <router-link to="/">Inicio</router-link>
              <router-link to="/novias">Novias</router-link>
              <router-link to="/fiesta">Fiesta</router-link>
              <router-link to="/complementos">Complementos</router-link>
              <router-link to="/about">Sobre mi</router-link>
              <router-link to="/contact">Contacto</router-link>
          </div>
        </nav>
      </div>
    </header>
    <transition name="appear" appear>
      <router-view id="main-content"/>
    </transition>
    <footer>
      <InstagramFeed class="instagram-feed" :token="instagramToken" title="Instagram" subtitle="@nohaypuntadasinhilo_" />
      <section class="copy-rigth">
        <span>No hay puntada sin hilo © {{new Date().getFullYear()}}</span>
        <div class="social-links">
          <a href="https://www.facebook.com/maryjesu.nohaypuntadasinhilo" aria-label="Link to facebook"><img alt="facebook link logo" src="@/assets/icons/facebook.svg"></a>
          <a href="https://www.instagram.com/nohaypuntadasinhilo_" aria-label="Link to instagram"><img alt="instagram link logo" src="@/assets/icons/instagram.svg"></a>
        </div>
      </section>
    </footer>
  </div>
</template>
<script>
import { tokens } from '@/tokens.js'
import InstagramFeed from '@/components/InstagramFeed.vue'

export default {
  name: 'App',
  data () {
    return {
      menuOpen: false,
      instagramToken: tokens().instagram
    }
  },
  methods: {
    showMenu () {
      this.menuOpen = !this.menuOpen
    }
  },
  watch: {
    '$route' (to, from) {
      this.menuOpen = false
    }
  },
  components: {
    InstagramFeed
  }
}
</script>
